import React, { createContext, useContext } from 'react'
import { createTheme } from '@mui/material'
import { useColorTheme } from './use-color-theme'

export const ThemeContext = createContext({
  mode: 'light',
  toggleColorMode: () => {},
  theme: createTheme({
    palette: {
      primary: {
        light: '#b22a00',
        main: '#FF7043',
        dark: '#ff6333',
        contrastText: '#FFF',
      },
      text: {
        primary: '#000',
        secondary: '#000',
      },
      gold: {
        light: '#FFD700',
        main: '#FFD700',
        dark: '#FFD700',
        contrastText: '#FFF',
      },
    },
  }),
  typography: {
    fontFamily: 'Jost',
  },
})

export const ThemeContextProvider = ({ children }) => {
  const value = useColorTheme()
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

export const useThemeContext = () => {
  return useContext(ThemeContext)
}
